<template>
  <article v-if="item && item.variation" class="cmp cmp-product-thumb" :data-testing="item.variation.id">
    <div :class="paddingClasses" :style="paddingInlineStyles">

      <div class="thumb-wishlist position-relative" :class="{'d-block': isVariationInWishList}">
        <add-to-wish-list :variation-id="item.variation.id"></add-to-wish-list>
      </div>

      <div class="thumb-image">
        <div class="prop-1-1">
          <slot name="item-image">
            <category-image-carousel :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                                     :alt="item | itemName"
                                     :title="item | itemName"
                                     :item-url="item | itemURL(urlWithVariationId)"
                                     :disable-carousel-on-mobile="disableCarouselOnMobile"
                                     :enable-carousel="$ceres.config.item.enableImageCarousel"
                                     ref="categoryImageCarousel">
            </category-image-carousel>
          </slot>
        </div>
        <client-only>
          <img
            v-if="item && item.variation && energyIconImageUrl"
            :src="energyIconImageUrl"
            class="img-fluid"
            :alt="$translate('GonserDT::Template.itemEnergyEfficiency') + energyIconAlt"
            :style="{
              position: 'absolute',
              bottom: 0,
              right: 0,
              width: energyIconWidth,
              height: 'unset'
            }"
            @click="showEnergyLightbox(energyLightboxImageUrl)"
          >
        </client-only>
      </div>
      <!-- STORE SPECIALS -->
      <slot name="store-special">
        <item-store-special v-if="item.item.itemType === 'set' || hasStoreSpecial"
                            :store-special="storeSpecial"
                            :recommended-retail-price="item.prices.rrp"
                            :variation-retail-price="item.prices.default"
                            :special-offer-price="item.prices.specialOffer"
                            :decimal-count="decimalCount"
                            :bundle-type="item.variation.bundleType || storeSpecial"
                            :item-type="item.item.itemType">
        </item-store-special>
      </slot>
      <!-- ./STORE SPECIALS -->

      <!-- ITEM DETAILS -->
      <slot name="item-details">
        <div class="thumb-content" @click="seeItem">
          <div class="d-flex justify-content-between align-items-center">
            <div class="thumb-feedback d-flex align-items-center">
              <div id="feedback-stars-average" class="feedback-stars-average feedback-category-view own">
                <div class="feedback-stars-background clearfix">
                  <div class="feedback-star"><i class="fa fa-star"></i></div>
                  <div class="feedback-star"><i class="fa fa-star"></i></div>
                  <div class="feedback-star"><i class="fa fa-star"></i></div>
                  <div class="feedback-star"><i class="fa fa-star"></i></div>
                  <div class="feedback-star"><i class="fa fa-star"></i></div>
                </div>
                <div class="feedback-stars-overlay-wrap"
                     v-if="item.item.feedbackDecimal > 0"
                     :style="{width: fillStars}">
                  <div class="feedback-stars-overlay clearfix">
                    <div class="feedback-star"><i class="fa fa-star"></i></div>
                    <div class="feedback-star"><i class="fa fa-star"></i></div>
                    <div class="feedback-star"><i class="fa fa-star"></i></div>
                    <div class="feedback-star"><i class="fa fa-star"></i></div>
                    <div class="feedback-star"><i class="fa fa-star"></i></div>
                  </div>
                </div>
              </div>
              <div v-show="showFeedbackCount" class="text-secondary ml-1" :style="{ transform: 'translateY(-2px)' }">({{ safeFeedbackCount }})</div>
            </div>
            <div class="thumb-availability"
                 data-toggle="tooltip"
                 data-placement="top"
                 v-tooltip
                 :title="item.variation.availability.names.name">
                 <span :class="'availability ' + getAvailabilityColor">
                  <i class="fa"
                    :class="{
                      'fa-check-circle': item.variation.availability.id === 1 || item.variation.availability.id === 3,
                      'fa-times-circle': item.variation.availability.id === 10,
                      'fa-circle': item.variation.availability.id !== 1 && item.variation.availability.id !== 3 && item.variation.availability.id < 7
                    }">
                  </i>
                </span>
            </div>
          </div>
          <div class="thumb-title"><!--
                    -->{{ item | itemName }}<!--
                    --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
          </div>
          <div class="thumb-meta mt-auto">
            <slot name="before-prices"></slot>

            <div class="prices d-inline-block">
              <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.price.value"
                   class="price-view-port">
                                <span class="crossprice">
                          {{ $translate(isRrpPriceType44 ? "GonserDT::Template.itemInsteadUvp" : "GonserDT::Template.itemUvp", {price: $options.filters.currency(item.prices.rrp.unitPrice.value, " ") }) }}
                                </span>
              </div>

              <div class="price">
                <template v-if="itemGraduatedPriceisCheapestSorting">
                  {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }} {{ $translate("Ceres::Template.itemFootnote") }}
                </template>
                <template v-else-if="itemGraduatedPricesalableVariationCount">
                  {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }} {{ $translate("Ceres::Template.itemFootnote") }}
                </template>
                <template v-else>
                  <span class="text-uppercase text-dark price-currency">{{ item.prices.default.currency }}</span><!--
                                    -->{{ item.prices.default.unitPrice.value | specialOffer(item.prices, "unitPrice", "value") | currency(" ") }}
                </template>
              </div>
            </div>
            <div class="thumb-additional d-inline-block h-100 float-right">
              <div class="d-flex align-items-end h-100">
                <div v-if="isGonserBoxItem"
                     class="thumb-gonser-box d-inline-block px-1"
                     :class="{'mb-1': showBasketBtn}"
                     data-toggle="tooltip"
                     data-placement="top"
                     v-tooltip
                     title="GONSERBOX">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       width="1.3em"
                       height="1.5em"
                       preserveAspectRatio="xMidYMid meet"
                       viewBox="0 0 640 512">
                    <path fill="#999999" d="M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5c-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64L69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z">
                    </path>
                  </svg>
                </div>
                <div v-if="!showBasketBtn" class="thumb-item-preview d-inline-block"
                     @mouseover.once="$store.dispatch('loadComponent', 'item-preview-modal')">
                  <a class="btn btn-link btn-sm text-primary pb-0 px-1" href="#" rel="nofollow"
                     @click.prevent="setAndOpenPreviewItem($event)">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="1.5em"
                         height="1.5em"
                         preserveAspectRatio="xMidYMid meet"
                         viewBox="0 0 16 16">
                      <g fill="currentColor">
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0a3.5 3.5 0 0 1-7 0z"/>
                      </g>
                    </svg>
                  </a>
                </div>
                <div class="add-to-basket-wrapper text-center">
                  <add-to-basket v-if="showBasketBtn"
                                 :variation-id="item.variation.id"
                                 :is-salable="!!item.filter && item.filter.isSalable"
                                 :has-children="!!item.item && item.item.salableVariationCount > 1"
                                 :interval-quantity="item.variation.intervalOrderQuantity || 1"
                                 :minimum-quantity="item.variation.minimumOrderQuantity"
                                 :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
                                 :order-properties="item.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                 :has-order-properties="item.hasOrderProperties"
                                 :has-required-order-property="item.hasRequiredOrderProperty"
                                 :use-large-scale="false"
                                 :show-quantity="false"
                                 :is-wish-list="showBasketBtn"
                                 :item-url="item | itemURL(urlWithVariationId)"
                                 :has-price="item | hasItemDefaultPrice"
                                 :with-success-icon="withSuccessIcon"
                                 :item-type="item.item.itemType">
                  </add-to-basket>
                </div>
              </div>
            </div>
          </div>

          <slot name="after-prices"></slot>
        </div>
      </slot>
      <!-- ./ITEM DETAILS  -->
    </div>
  </article>
  <div v-else>
    <p>Loading...</p>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import ItemStoreSpecial from "./ItemStoreSpecial.vue";
import {getSlotData} from "../../helper/getSlotData";
import { isGonserBoxItem as detectGonserBoxItem } from "../../helper/gonserBox";
const ModalService  = require("../../services/ModalService");

const energyIconImages = {
    'alt_A+++': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/alt_A3plus_Left.png',
    'alt_A++': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/alt_A2plus_Left.png',
    'alt_A+': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/alt_Aplus_Left.png',
    'alt_A': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/alt_A_Left.png',
    'alt_B': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/alt_B_Left.png',
    'alt_C': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/alt_C_Left.png',
    'alt_D': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/alt_D_Left.png',
    'neu_A': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/neu_A_Left.png',
    'neu_B': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/neu_B_Left.png',
    'neu_C': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/neu_C_Left.png',
    'neu_D': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/neu_D_Left.png',
    'neu_E': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/neu_E_Left.png',
    'neu_F': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/neu_F_Left.png',
    'neu_G': 'https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/Gonser/icons/EnergieEffizienzIcons/neu_G_Left.png',
}

export default {
  components: {
    CategoryImageCarousel,
    ItemStoreSpecial
  },

  props: {
    decimalCount:
        {
          type: Number,
          default: 0
        },
    imageUrlAccessor:
        {
          type: String,
          default: "urlMiddle"
        },
    itemData:
        {
          type: Object
        },
    disableCarouselOnMobile:
        {
          type: Boolean
        },
    paddingClasses:
        {
          type: String,
          default: null
        },
    paddingInlineStyles:
        {
          type: String,
          default: null
        },
    forceUrlWithVariationId:
        {
          type: Boolean,
          default: false
        },
    showBasketBtn:
        {
          type: Boolean,
          default: false
        },
    withSuccessIcon:
        {
          type: Boolean,
          default: false
        }
  },

  jsonDataFields: [
    "itemDataRef"
  ],
  data() {
    return {
      windowWidth: (typeof window !== "undefined" && window.innerWidth) ? window.innerWidth : 1200, // SSR-safe
    };
  },
  mounted() {
  this.updateWindowWidth();
  window.addEventListener('resize', this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },

  computed:
      {
        itemSlotData: getSlotData('item-data'),

        item()
        {
          return this.itemData || this.itemSlotData || this.itemDataRef;
        },

        isVariationInWishList()
        {
          return this.wishListIds.includes(this.item.variation.id);
        },

        hasStoreSpecial()
        {
          if (this.item.variationProperties)
          {
            for (let variationProperty of this.item.variationProperties)
            {
              if (variationProperty.properties)
              {
                for (let property of variationProperty.properties)
                {
                  if (property.id === 39 || property.id === 31)
                  {
                    return true
                  }
                }
              } else if ( variationProperty.property.id === 39 || variationProperty.property.id === 31)
              {
                return true
              }
            }
          }
          return false
        },

        storeSpecial() {

          try {
            if (this.item.variationProperties) {
              for (let variationProperty of this.item.variationProperties) {

                if (variationProperty.properties) {
                  for (let property of variationProperty.properties) {

                    if (property.id === 39) {

                      return {
                        names: {
                          name: property.values.value
                        }
                      };
                    } else if (property.id === 31 && property.values.length > 0) {

                      return {
                        names: {
                          name: property.values[0].value
                        }
                      };
                    }
                  }
                } else if (variationProperty.property && (variationProperty.property.id === 39 || variationProperty.property.id === 31)) {

                  return {

                    names: {
                      name: variationProperty.values.value
                    }
                  };
                }
              }
            }
            return this.item.item.storeSpecial;
          } catch (error) {
            //eslint-disable-next-line no-console
            console.error("Error in storeSpecial", error);
          }
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
          return this.item.texts;
        },

        itemPrice()
        {
          return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        basePrice()
        {
          return this.item.prices.default.basePrice;
        },

        itemPriceGraduated()
        {
          let unitPrice;
          if (App.config.item.enableGraduatedPrices) {
            unitPrice = this.item.prices.graduatedPrices.length > 0
                ? this.item.prices.graduatedPrices[0].unitPrice
                : this.item.prices.default.unitPrice;
          } else {
            unitPrice = this.item.prices.default.unitPrice;
          }

          return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemGraduatedPriceisCheapestSorting()
        {
          return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
        },

        itemGraduatedPricesalableVariationCount()
        {
          return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
        },

        itemSetPrice()
        {
          return this.$options.filters.currency(
              this.item.prices.default.price.value,
              this.item.prices.default.currency
          );
        },

        urlWithVariationId()
        {
          return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        hasCrossPrice() {
          const hasRrpPrice = !!this.item.prices.rrp &&
              this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

          const hasBeforePrice = !!this.item.prices.specialOffer &&
              !!this.item.prices.default &&
              this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

          return hasRrpPrice || hasBeforePrice;
        },

        isRrpPriceType44() {
          return !!this.item.prices.rrp
            && !!this.item.prices.rrp.data
            && Number(this.item.prices.rrp.data.salesPriceId) === 44;
        },

        getAvailabilityColor()
        {
          let availabilityColor = "";

          switch (this.item.variation.availability.id)
          {
            case 1:
              availabilityColor = "text-success";
              break;
            case 2:
              availabilityColor = "text-success";
              break;
            case 3:
              availabilityColor = "text-warning";
              break;
            case 4:
              availabilityColor = "text-warning";
              break;
            case 5:
              availabilityColor = "text-warning";
              break;
            case 6:
              availabilityColor = "text-warning";
              break;
            case 7:
              availabilityColor = "text-danger";
              break;
            case 8:
              availabilityColor = "text-danger";
              break;
            case 9:
              availabilityColor = "text-danger";
              break;
            case 10:
              availabilityColor = "text-danger";
              break;
            default:
              break;
          }
          return availabilityColor;
        },

        fillStars() {
          return (this.item.item.feedbackDecimal * 100) / 5 + '%'
        },

        ...mapState({
          showNetPrices: state => state.basket.showNetPrices,
          wishListIds: state => state.wishList.wishListIds
        }),

        energyIconImageUrl() {
          return energyIconImages[this.showEnergyIcon(this.item)] || '';
        },
        energyIconAlt() {
          const raw = this.showEnergyIcon(this.item) || '';
          return raw.replace(/^(alt_|neu_)/, '');
        },
        energyLightboxImageUrl() {
          if (
            this.item &&
            this.item.images &&
            Array.isArray(this.item.images.all)
          ) {
            // Defensive: filter out any non-plain objects
            const images = this.item.images.all.filter(img =>
              img && typeof img === "object" && !Array.isArray(img)
            );
            const found = images.find(
              img => img.position === 99 && img.urlSecondPreview && typeof img.urlSecondPreview === "string"
            );
            return found ? found.urlSecondPreview : "";
          }
          return "";
        },
        energyIconWidth() {
          return this.windowWidth <= 576 ? '38px' : '42px';
        },

        safeFeedbackCount() {
          const countRaw = this.item && this.item.item && this.item.item.feedbackCount;
          const count = Number(countRaw);
          return Number.isFinite(count) ? count : 0;
        },

        showFeedbackCount() {
          const count = Number(this.item && this.item.item && this.item.item.feedbackCount);
          return count >= 3;
        },

        isGonserBoxItem()
        {
          return detectGonserBoxItem(this.item ? this.item.variationProperties : null);
        },
      },

  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    seeItem()
    {
      const url = this.$options.filters.itemURL(
          this.item,
          this.urlWithVariationId
      )
      window.location.assign(url);
    },

    setAndOpenPreviewItem(event)
    {
      this.$store.dispatch("setItemPreviewDetails", {
        item: this.item
      });
      ModalService
          .findModal(document.getElementById("itemPreviewModal"))
          .show();
      event.preventDefault();
      event.stopPropagation();
    },

    showEnergyIcon(item) {
      if (!item || !item.variationProperties) return "";

      for (const variationProperty of item.variationProperties) {
        if (Array.isArray(variationProperty.properties)) {
          for (const property of variationProperty.properties) {
            if (property.id === 47 && property.values) {
              // Handle both array and object for values
              if (Array.isArray(property.values) && property.values.length > 0 && property.values[0].value) {
                return property.values[0].value;
              }
              if (property.values.value) {
                return property.values.value;
              }
            }
          }
        }
        // Also check if property is directly on variationProperty (for completeness)
        if (
          variationProperty.property &&
          variationProperty.property.id === 47 &&
          variationProperty.values
        ) {
          if (Array.isArray(variationProperty.values) && variationProperty.values.length > 0 && variationProperty.values[0].value) {
            return variationProperty.values[0].value;
          }
          if (variationProperty.values.value) {
            return variationProperty.values.value;
          }
        }
      }
      return "";
    },
    showEnergyLightbox(imgUrl) {
      if (window.openEnergyLightbox) {
        window.openEnergyLightbox(imgUrl);
      }
    }
  }
}
</script>
